import React, {PropTypes} from 'react';
import SelectEmployee from '../../../components/common/forms/SelectEmployee';
import {connect} from 'react-redux';
import Checkbox from 'material-ui/Checkbox';
import SearchFilter from './LeaveSearchFilter';
import axios from 'axios';
import toastr from 'toastr';
import LeaveBalanceTable from './LeaveBalanceTable';
import LeaveTransTable from './LeaveTransTable';
import LeaveTransSearchFilter from './LeaveTransSearchFilter';
import moment from 'moment';

class LeaveBalanceHome extends React.Component {

    constructor() {
      super();
      this.state={leaveBalance: [],leaveTrans: []}
      this.onSubmit = this.onSubmit.bind(this);
      this.onSubmitTrans = this.onSubmitTrans.bind(this);


    }
    componentDidMount()
    {
      this.props.changeBanner("leave Balance & Transactions");
    }
    onSubmit(request)
    {
      console.log(request);
      if(request.selected!=null)
      {
        axios.get(process.env.REQ_URL + "/leaveBalanceEmp?q="+request.selected,{withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=>{
          this.setState({leaveBalance: response.data.data});
          return;
        }).catch((error)=>{
          toastr.error("Error Occurred");
        })
      }
      else if(request.option1==true)
      {

        axios.get(process.env.REQ_URL + "/leaveBalanceEmp?q="+this.props.option1,{withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=>{
          this.setState({leaveBalance: response.data.data});
          return;
        }).catch((error)=>{
          toastr.error("Error Occurred");
        })
      }

      else if(request.option2==true)
      {

        axios.get(process.env.REQ_URL + "/leaveBalanceEmp?q="+this.props.option2,{withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=>{
          this.setState({leaveBalance: response.data.data});
          return;
        }).catch((error)=>{
          toastr.error("Error Occurred");
        })
      }
    }
  onSubmitTrans(request)
  {



    console.log(request);
    if(request.startDate==null || request.endDate == null) {
      toastr.error("Select Dates");a
      return;
    }

    let requestObject ={};
    requestObject.startDate = moment(request.startDate).format('YYYY-MM-DD');
    requestObject.endDate = moment(request.endDate).format('YYYY-MM-DD');
    requestObject.empId = request.selected;
    requestObject.type= request.option1?this.props.option1:(request.option2?this.props.option2:null);

      axios.get(process.env.REQ_URL + "/leave/historyFilter?q="+JSON.stringify(requestObject),{withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=>{
        this.setState({leaveTrans: response.data.data});
        return;
      }).catch((error)=>{
        toastr.error("Error Occurred");
      })

  }

    render() {
        return (
          <div>
            <div className="col-md-12" style={{borderTop: 'solid 1px',borderBottom: 'solid 1px'}}>
              <h2><u>Leave Balance View</u></h2>
            <SearchFilter
              activeEmployees={this.props.activeEmployees}
              option1={this.props.option1} option2={this.props.option2} onSubmit={this.onSubmit}/>
            <LeaveBalanceTable data={this.state.leaveBalance}/>
              </div>
            <div className="col-md-12" style={{borderTop: 'solid 1px',borderBottom: 'solid 1px'}}>
              <h2><u>Leave Transaction View</u></h2>
            <LeaveTransSearchFilter   activeEmployees={this.props.activeEmployees}
                                      option1={this.props.option1} option2={this.props.option2} onSubmit={this.onSubmitTrans}/>

            <LeaveTransTable data={this.state.leaveTrans} />
              </div>


          </div>

        );
    }
}
function mapStateToProps(state,ownState)
{
  return{
    activeEmployees: state.employees
  }
}

LeaveBalanceHome.defaultProps = {
  option1: "all",
  option2: "exit"
};

export default connect(mapStateToProps)(LeaveBalanceHome);





/** WEBPACK FOOTER **
 ** ./src/feature/leave/LeaveBalance/LeaveBalanceHome.js
 **/